import type { RootState } from '../store';

export const selectFeatureFlags = (state: RootState) => state.featureFlags.flags;
export const selectFeatureFlagsLoading = (state: RootState) => state.featureFlags.loading;
export const selectFeatureFlagsError = (state: RootState) => state.featureFlags.error;

export const selectIsFeatureEnabled = (flagName: string) => (state: RootState) =>
  state.featureFlags.flags.includes(flagName);

export const selectFeatureFlagsHydrated = (state: RootState) => state.featureFlags.hydrated;
